import * as React from "react";
import { forwardRef } from "react";
const SvgIconCaretTransparent = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 3, viewBox: "0 0 6 3", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0L3 3L6 0H0Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIconCaretTransparent);
export { ForwardRef as ReactComponent };
